import Tools from "../Tools";

/**
 * OneApi系统相关API
 */
export default class OneApi {
    /**
     * 获取可用模型列表
     */
    public GetAvailableModelListAsync() {
        return Tools.FetchAsync<string[]>("OneApi/GetAvailableModelList", {}, "GET");
    }
}